import { reportError } from "../api/home";
import utils from "./utils";
// 类型定义
interface PurchaseParams {
  currencyId?: string;
  amount?: number;
}

interface WithdrawParams {
  currencyId?: string;
  amount?: number;
}

interface PaidItem {
  id: string;
  time: number;
}

// TODO: 实现付费响应接口
// interface _PaidResponse {
//   list: Array<{
//     id: string;
//     first?: boolean;
//     usdAmount?: number;
//     amount?: number;
//   }>;
// }

/** 通过 reportError 记录首充/充值回传事件 */
function recordPixelEvent(
  type: "gtag" | "fb" | "tt",
  eventType: "first_purchase" | "purchase",
  item: { id?: string; first?: boolean; usdAmount?: number; amount?: number },
  pixelEvent:
    | {
        ttEventName?: string;
        fbEventName?: string;
        eventId?: string;
        gtagEventName?: string;
      }
    | undefined
): void {
  if (!pixelEvent) return;
  reportError({
    url: window.location.href,
    content:
      type +
      " response: " +
      JSON.stringify({
        type: "pixel_event",
        eventType,
        orderId: item.id,
        first: item.first,
        usdAmount: item.usdAmount,
        amount: item.amount,
        ttEventName: pixelEvent.ttEventName,
        fbEventName: pixelEvent.fbEventName,
        gtagEventName: pixelEvent.gtagEventName,
        eventId: pixelEvent.eventId,
        hasGA: window.gtag ? true : false,
        hasFB: window.fbq ? true : false,
        hasTT: window.ttq ? true : false,
      }),
    version: utils.getAppVersion() ?? "",
  });
}

export const CE_RECHARGE_BOTTOM = "CE_RECHARGE_BOTTOM";
export const CE_RECHARGE_TOP = "CE_RECHARGE_TOP";
export const CE_RECHARGE_TOP_NEW = "CE_RECHARGE_TOP_NEW";
export const CE_RECHARGE_AVATAR = "CE_RECHARGE_AVATAR";
export const CE_REGISTER_PRE = "CE_REGISTER_PRE";
export const CE_REGISTER_PRE_SUBMIT = "CE_REGISTER_PRE_SUBMIT";
export const CE_REGISTER_PRE_SHOW = "CE_REGISTER_PRE_SHOW";
export const CE_REGISTER_PRE_PHONE = "CE_REGISTER_PRE_PHONE";
export const CE_REGISTER_PRE_EMAIL = "CE_REGISTER_PRE_EMAIL";
export const CE_REGISTER_PRE_PASSWORD = "CE_REGISTER_PRE_PASSWORD";
export const CE_REGISTER_PRE_IMAGECODE = "CE_REGISTER_PRE_IMAGECODE";
export const CE_REGISTER_PRE_LATER = "CE_REGISTER_PRE_LATER";
export const CE_ADD_TO_HOME_CLICK = "CE_ADD_TO_HOME_CLICK";
export const CE_ADD_TO_HOME_DONE = "CE_ADD_TO_HOME_DONE";

export const AdUtils = {
  onPageView: () => {
    AdUtils.onGTag("event", "page_view");
    if (window.ttq) {
      (window.ttq as any)?.page();
    }
  },
  onCustomEvent: (e: any) => {
    AdUtils.onGTag("event", e);
    AdUtils.onBranch(e);
    AdUtils.onTtqPixel(e);
    AdUtils.onFbPixel("trackCustom", e);
  },
  onVerifyCodeBegin: () => {
    AdUtils.onGTag("event", "verify_code_begin");
  },
  onVerifyCodePass: () => {
    AdUtils.onGTag("event", "verify_code_pass");
  },
  onRegister: (params?: any) => {
    if (params?.gtagEventName) {
      AdUtils.onGTag("event", params?.gtagEventName);
    }
    if (params?.fbEventName) {
      AdUtils.onFbPixel(
        "track",
        params.fbEventName,
        {},
        { eventID: params?.eventId }
      );
    }
    if (params?.ttEventName) {
      AdUtils.onTtqPixel(params.ttEventName, {
        event_id: params?.eventId,
      });
    }
    AdUtils.onBranch("COMPLETE_REGISTRATION");
    AdUtils.onAndroidEvent("COMPLETE_REGISTRATION");
  },
  onLogin: (params?: any) => {
    AdUtils.onGTag("event", "login");
    if (params?.gtagEventName) {
      AdUtils.onGTag("event", params?.gtagEventName);
    }
    if (params?.fbEventName) {
      AdUtils.onFbPixel(
        "track",
        params.fbEventName,
        {},
        { eventID: params?.eventId }
      );
    }
    if (params?.ttEventName) {
      AdUtils.onTtqPixel(params.ttEventName, {
        event_id: params?.eventId,
      });
    }
  },
  onFirstPurchaseSuccess: (pixelEvent: any, item: any) => {
    if (!pixelEvent) return;
    if (
      pixelEvent.ttEventName === "Purchase" ||
      pixelEvent.fbEventName === "Purchase" ||
      pixelEvent.gtagEventName === "purchase"
    ) {
      return;
    }
    if (pixelEvent.gtagEventName) {
      AdUtils.onGTag("event", pixelEvent.gtagEventName);
      AdUtils.onGTag("event", "first_purchase");
      recordPixelEvent("gtag", "first_purchase", item, pixelEvent);
    }
    const amountParams = { value: item?.usdAmount, currency: "USD" };
    if (pixelEvent.fbEventName) {
      AdUtils.onFbPixel(
        "track",
        pixelEvent.fbEventName,
        pixelEvent.includeValue ? amountParams : {},
        {
          eventID: pixelEvent?.eventId,
        }
      );
    }
    if (pixelEvent.ttEventName) {
      const orderId = item.id;
      const ttProperties: Record<string, unknown> = {
        ...amountParams,
        event_id: pixelEvent?.eventId,
      };
      if (pixelEvent.ttEventName === "AddToWishlist" && orderId) {
        ttProperties.order_id = orderId;
        ttProperties.contents = [
          {
            content_id: orderId,
            content_type: "product",
            quantity: 1,
            price: item?.usdAmount,
          },
        ];
      }
      AdUtils.onTtqPixel(pixelEvent.ttEventName, ttProperties);
    }
    AdUtils.onBranch("ADD_TO_WISHLIST");
  },
  onPurchaseSuccess: (pixelEvent: any, item: any) => {
    if (!pixelEvent) return;
    if (item.usdAmount) {
      const amountParams = { currency: "USD", value: item.usdAmount };
      if (pixelEvent.gtagEventName) {
        AdUtils.onGTag("event", pixelEvent.gtagEventName, amountParams);
      }
      if (pixelEvent.fbEventName) {
        if (pixelEvent.customEvent) {
          AdUtils.onFbPixel(
            "trackCustom",
            pixelEvent.fbEventName,
            amountParams,
            {
              eventID: pixelEvent?.eventId,
            }
          );
        } else {
          AdUtils.onFbPixel("track", pixelEvent.fbEventName, amountParams, {
            eventID: pixelEvent?.eventId,
          });
        }
      }
      if (pixelEvent.ttEventName) {
        AdUtils.onTtqPixel(pixelEvent.ttEventName, {
          ...amountParams,
          event_id: pixelEvent?.eventId,
        });
      }
      AdUtils.onBranch("ADD_TO_CART");
      AdUtils.onBranch("PURCHASE", amountParams);
      AdUtils.onAndroidEvent("PURCHASE", amountParams);
    } else {
      if (pixelEvent.fbEventName) {
        AdUtils.onFbPixel(
          "track",
          pixelEvent.fbEventName,
          {},
          {
            eventID: pixelEvent?.eventId,
          }
        );
      }
      if (pixelEvent.gtagEventName) {
        AdUtils.onGTag("event", pixelEvent.gtagEventName);
      }
      if (pixelEvent.ttEventName) {
        AdUtils.onTtqPixel(pixelEvent.ttEventName, {
          event_id: pixelEvent?.eventId,
        });
      }
      AdUtils.onBranch("ADD_TO_CART");
      AdUtils.onBranch("PURCHASE");
      AdUtils.onAndroidEvent("PURCHASE");
    }
  },
  onInitPurchase: ({ amount: _amount }: PurchaseParams) => {
    AdUtils.onGTag("event", "begin_checkout");
    AdUtils.onFbPixel("track", "InitiateCheckout", {
      currency: "USD",
      value: _amount,
    });
    AdUtils.onTtqPixel("InitiateCheckout", {
      currency: "USD",
      value: _amount,
    });
    AdUtils.onBranch("INITIATE_PURCHASE");
  },
  onInitWithdraw: ({ currencyId, amount }: WithdrawParams) => {
    AdUtils.onGTag("event", "add_to_wishlist", {
      currency: currencyId,
      value: amount,
    });
  },
  onShare: () => {
    AdUtils.onGTag("event", "share");
    AdUtils.onFbPixel("trackCustom", "Share");
    AdUtils.onBranch("SHARE");
  },
  onError: (errorInfo: string) => {
    AdUtils.onGTag("event", "exception", {
      description: errorInfo,
    });
  },
  onGTag: (...args: any[]) => {
    if (!window.gtag) return;
    window.gtag(...args);
  },
  onFbPixel: (...args: any[]) => {
    if (!window.fbq) {
      return;
    }
    window.fbq(...args);
  },
  onTtqPixel: (...args: any[]) => {
    if (!window.ttq) return;
    window.ttq.track(...args);
  },
  onBranch: (...args: any[]) => {
    if (!window.branch) return;
    window.branch.logEvent(...args);
  },

  onAndroidEvent: (eventName: string, params?: any) => {
    if (!window.android) return;
    try {
      if (params) {
        window.android.logEvent(eventName, JSON.stringify(params));
      } else {
        window.android.logEvent(eventName);
      }
    } catch {
      return;
    }
  },
  isEnablePixel: () => {
    return (
      ((window.gtag ||
        window.fbq ||
        window.kwaiq ||
        window.ttq ||
        window.branch ||
        window.bge ||
        window._tmr ||
        window.snaptr ||
        window.android) &&
        true) ||
      false
    );
  },
  holdPurchase: (id?: string) => {
    try {
      if (!id) return;
      // const now = utils.getServerTime();
      const now = new Date().getTime();
      let paidList: PaidItem[] = utils.getObject("paidList") || [];
      paidList = paidList.filter(x => now - x.time < 43200000);
      paidList.push({ id: id, time: now });
      if (paidList.length > 10) {
        paidList = paidList.slice(paidList.length - 10);
      }
      utils.setObject("paidList", paidList);

      setTimeout(() => {
        AdUtils.checkPurchase();
      }, 180 * 1000);
    } catch (e) {
      console.error(e);
    }
  },
  checkPurchase: async () => {
    if (global._checkPurchase) return;
    global._checkPurchase = true;
    try {
      await AdUtils._checkPurchase();
    } catch {
      // 忽略错误
    }
    global._checkPurchase = false;
  },
  _checkPurchase: async () => {
    try {
      // const now = utils.getServerTime();
      const now = new Date().getTime();
      const paidList: PaidItem[] = utils.getObject("paidList") || [];
      if (!paidList || !paidList.length) {
        return;
      }
      let fitList = paidList.filter(x => now - x.time < 43200000);
      if (!fitList.length) {
        utils.setObject("paidList", null);
        return;
      }
      const resp: any = await utils.request("/api/pay/paid_list", {
        ids: fitList.map(x => x.id),
      });
      if (resp.data.list && resp.data.list.length) {
        for (const item of resp.data.list) {
          if (item.pixelEvents && item.pixelEvents.length > 0) {
            for (const pixelEvent of item.pixelEvents) {
              if (!pixelEvent) continue;
              if (item.first) {
                AdUtils.onFirstPurchaseSuccess(pixelEvent, item);
              }
              if (
                pixelEvent.ttEventName === "Purchase" ||
                pixelEvent.fbEventName === "Purchase" ||
                pixelEvent.gtagEventName === "purchase" ||
                pixelEvent.gtagEventName === "redeposit" ||
                pixelEvent.ttEventName === "Redeposit" ||
                pixelEvent.fbEventName === "Redeposit"
              ) {
                AdUtils.onPurchaseSuccess(pixelEvent, item);
              }
            }
          }

          fitList = fitList.filter(x => x.id !== item.id);
          utils.setObject("paidList", fitList);
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
};
